import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createBrand } from "../../redux/features/brands/brandsSlice";
import { toast } from "react-toastify";

function AddNewBrand({ refetchBrands }) {
  const dispatch = useDispatch();
  const { createBrandLoading } = useSelector((state) => state.brands);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    logo: null,
  });
  const [errors, setErrors] = useState({});

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "logo") {
      setFormData((prev) => ({
        ...prev,
        logo: files[0],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required.";
    if (!formData.logo) newErrors.logo = "Logo is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fill all required fields correctly.");
      return;
    }
    try {
      const payload = new FormData();
      payload.append("name", formData.name);
      payload.append("logo", formData.logo);

      await dispatch(createBrand(payload)).unwrap();
      toast.success("Brand Created Successfully");
      setFormData({ name: "", logo: "" });
      handleClose();
      refetchBrands();
    } catch (error) {
      if (error?.errors) {
        const formattedErrors = {};

        Object.keys(error.errors).forEach((key) => {
          formattedErrors[key] = error.errors[key][0]; // take first message
        });

        setErrors(formattedErrors);
      } else if (error?.message) {
        toast.error(error.message);
      } else {
        toast.error("Creation Failed");
      }
    }
  };

  return (
    <div className="flex justify-end ">
      <button
        onClick={handleOpen}
        className="bg-lightPurple hover:bg-purpleColor p-2 rounded-lg text-white"
      >
        <FontAwesomeIcon icon={faPlus} className="mr-1" />
        Add New Brand
      </button>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-lg w-[45%]  p-10 relative">
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <h2 className="text-xl font-semibold border-b border-gray-200 mb-6 pb-5">
              Add New Brand
            </h2>

            <form onSubmit={handleSubmit} className="space-y-10">
              <div className="grid grid-cols-1 gap-5">
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Brand Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter Brand Name"
                    className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-purpleColor"
                  />
                  {errors.name && (
                    <p className="text-red-500 text-sm">{errors.name}</p>
                  )}
                </div>
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Logo <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  name="logo"
                  accept="image/*"
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-purpleColor"
                />
                {errors.logo && (
                  <p className="text-red-500 text-sm">{errors.logo}</p>
                )}
              </div>

              <div className="flex justify-end gap-3 mt-6">
                <button
                  type="button"
                  onClick={handleClose}
                  className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={createBrandLoading}
                  className={`px-4 py-2 rounded-md text-white ${
                    createBrandLoading
                      ? "bg-lightPurple/60 cursor-not-allowed"
                      : "bg-lightPurple hover:bg-purpleColor"
                  }`}
                >
                  {createBrandLoading ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddNewBrand;
